export const NEW_TRADE_ACTIONS = {
  NEXT: 'Next',

  SHIPPING_AND_BILLING: 'Shipping & Billing',

  NEXT_SHIPPING: 'Next: Shipping',

  NEXT_REVIEW_OFFER: 'Next: Review Offer',
  REVIEW_OFFER: 'Review Offer',
  SUBMIT_OFFER: 'Submit Offer',
  UPDATE_OFFER: 'Update Offer',

  REVIEW_ORDER: 'Review Order',
  NEXT_REVIEW_AND_PAY: 'Next: Review & Pay',

  NEXT_START_LISTING: 'Next: Start Listing',
  NEXT_RESUME_LISTING: 'Next: Resume Listing',
  AUTHENTICATION: 'Authentication',
  REVIEW_LISTING: 'Review Listing',
  LIST: 'List',
  UPDATE_LISTING: 'Update Listing',

  REVIEW_SALE: 'Review Sale',
} as const

export const NEW_TRADE_STEPS = {
  BID_FORM: 'BID_FORM',
  BUY_FORM: 'BUY_FORM',
  ASK_FORM: 'ASK_FORM',
  SELL_FORM: 'SELL_FORM',
  SHIPPING_AND_BILLING: 'SHIPPING_AND_BILLING',
} as const

export function isAction(
  currentAction: string | undefined,
  desiredAction: keyof typeof NEW_TRADE_ACTIONS
) {
  const mappedAction = NEW_TRADE_ACTIONS[desiredAction]

  return currentAction?.toLowerCase() === mappedAction.toLowerCase()
}
